export enum DemandAccountStatus {
    Created = 'STATUS_CREATED',
    Accepted = 'STATUS_ACCEPTED',
    PartiallyAccepted = 'STATUS_PARTIALLY_ACCEPTED',
    Declined = 'STATUS_DECLINED',
}
